export default __webpack_public_path__ + "static/media/481477a3b63ebc0291e481d450bca48a1580308330560.ad06938c.webp";